export function debounce(fn: Function, waitMs: number, leading: boolean = false) {
  let timeoutId: number | null = null;

  function debounced(this: any, ...args: any[]) {
    let fnThis = this;
    let fnArguments = arguments;

    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    if (leading && timeoutId === null) {
      fn.apply(fnThis, fnArguments);
    }
    timeoutId = window.setTimeout(() => {
      fn.apply(fnThis, fnArguments);
      timeoutId = null;
    }, waitMs);
  };

  return debounced;
}
